import React from 'react'
import { AppToolbarCreateButton } from "@components"
import { MAPPING_TYPE } from "Pages/User/CustomMapping/@constants"
import { setMappingFormData } from "Pages/User/CustomMapping/@signals"

export default function CreateCustomMappingButton({ path }) {

	return <AppToolbarCreateButton
		divider={false}
		label={`Create custom ${path === MAPPING_TYPE.ACRISS ? "ACRISS" : "Category"}`}
		onClick={() => setMappingFormData(path, 'create')}
	/>
}